import React, { useMemo, useState } from "react"
import { Text, View } from "react-native"
import { textStyles } from "../../style"
import { getChartFocusTooltipPlacement } from "./environmental-impact-chart-tooltip-position"

const DEFAULT_TOOLTIP_SIZE = { width: 168, height: 32 } as const

type EnvironmentalImpactChartTooltipProps = {
  label: string
  valueText: string
  focusX: number
  focusY: number
  chartWidth: number
  chartHeight: number
  bgMain: string
  borderColor: string
  textMain: string
}

export const EnvironmentalImpactChartTooltip = ({
  label,
  valueText,
  focusX,
  focusY,
  chartWidth,
  chartHeight,
  bgMain,
  borderColor,
  textMain,
}: EnvironmentalImpactChartTooltipProps): JSX.Element => {
  const [size, setSize] = useState(DEFAULT_TOOLTIP_SIZE)

  const placement = useMemo(
    () =>
      getChartFocusTooltipPlacement({
        focusX,
        focusY,
        chartWidth,
        chartHeight,
        bubbleWidth: size.width,
        bubbleHeight: size.height,
      }),
    [chartHeight, chartWidth, focusX, focusY, size.height, size.width]
  )

  return (
    <View
      pointerEvents="none"
      onLayout={(e) => {
        const { width, height } = e.nativeEvent.layout
        if (
          width > 0 &&
          height > 0 &&
          (Math.abs(width - size.width) > 1 || Math.abs(height - size.height) > 1)
        ) {
          setSize({ width, height })
        }
      }}
      style={{
        position: "absolute",
        left: placement.left,
        top: placement.top,
        maxWidth: Math.max(120, chartWidth - 16),
        paddingVertical: 6,
        paddingHorizontal: 8,
        borderRadius: 10,
        backgroundColor: bgMain,
        borderWidth: 1,
        borderColor,
        zIndex: 2,
      }}
    >
      <Text style={[textStyles.subscript, { color: textMain }]}>
        {(label ? `${label} • ` : "")}
        {valueText}
      </Text>
    </View>
  )
}
